import React from "react";
import Grid from "@material-ui/core/Grid";
import {
  getAutocompleteLabel,
  normalizeAutocompleteValue,
} from "../../../utils/autocomplete";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
// import moment, { add } from "moment";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  // DatePicker,
  // TimePicker,
  // DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import "date-fns";
import { ca } from "date-fns/locale";

//Estilos
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
  },
  formControl2: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
    margin: theme.spacing(1),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export default function ViajeDetalles(props) {
  const classes = useStyles();
  const filter = createFilterOptions();

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Información del viaje
      </Typography>

      <Grid container spacing={3}>
        {props.values.perfilLog == 5 ? (
          <Grid item xs={12}>
            <FormControl className={classes.formControl2}>
              <Autocomplete
                fullWidth
                value={normalizeAutocompleteValue(props.values.idClienteSol, "nombre")}
                onChange={(event, newValue) => {
                  if (typeof newValue == "string") {
                    props.handleClientes(newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    props.handleClientes(newValue.inputValue);
                  } else {
                    props.handleClientes(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue != "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      nombre: `Usar: "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={props.values.clientes}
                getOptionLabel={(option) => getAutocompleteLabel(option, "nombre")}
                renderOption={(option) => option.nombre}
                // style={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Escribe el Cliente que solicita"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.urgente}
                  onChange={(event) =>
                    props.handleUrgente(event.target.checked)
                  }
                />
              }
              label="Urgente"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.alta}
                  onChange={(event) => props.handleAlta(event.target.checked)}
                />
              }
              label="Alta"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.ingres}
                  onChange={(event) => props.handleIngres(event.target.checked)}
                />
              }
              label="Ingres"
            />
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <InputLabel id="demo-simple-select-label">
              Selecciona el tipo de vehículo
            </InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props.values.tipo}
              name="tipo"
              onChange={(e) => props.handleVehiculo(e.target.value)}
            >
              <MenuItem value={"TURISME"}>TURISME</MenuItem>
              <MenuItem value={"ADAPTAT"}>ADAPTAT</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <Autocomplete
              fullWidth
              value={normalizeAutocompleteValue(props.values.destino)}
              onChange={(event, newValue) => {
                if (typeof newValue == "string") {
                  props.handleDestino(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handleDestino(newValue.inputValue);
                } else {
                  props.handleDestino(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue != "") {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Usar: "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.todosDestinos}
              getOptionLabel={(option) => getAutocompleteLabel(option)}
              renderOption={(option) => option.title}
              // style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Escribe un pueblo destino"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <TextField
              required
              id="city"
              name="city"
              type="number"
              label="Cantidad se sesiones"
              fullWidth
              value={props.values.sesiones}
              onChange={props.handleData("sesiones")}
              defaultValue={props.values.sesiones}
            />
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.values.mananaTarde}
                onChange={(event) =>
                  props.handleMananaTarde(event.target.checked)
                }
              />
            }
            label="Marcar para crear Viajes Mañana y tarde"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl2}>
            <Autocomplete
              fullWidth
              value={normalizeAutocompleteValue(props.values.direccionHospital)}
              onChange={(event, newValue) => {
                if (typeof newValue == "string") {
                  props.handleCentros(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handleCentros(newValue.inputValue);
                } else {
                  props.handleCentros(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue != "") {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Usar: "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.todosCentros}
              getOptionLabel={(option) => getAutocompleteLabel(option)}
              renderOption={(option) => option.title}
              // style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Escribe el Centro de Asistencia"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>
        {props.values.mananaTarde ? (
          <>
            {/* Parte de la mañana */}
            <Grid item xs={12} container justify="space-around">
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ca}>
                <KeyboardDatePicker
                  fullWidth
                  margin="normal"
                  id="date-picker-dialog-morning"
                  label="Selecciona una fecha (Mañana)"
                  format="dd/MM/yyyy"
                  value={props.values.fecha}
                  onChange={(date) => props.handleConfirm(date, "FechaManana")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  fullWidth
                  margin="normal"
                  id="time-picker-morning"
                  label="Selecciona una hora (Mañana)"
                  ampm={false}
                  value={props.values.hora}
                  onChange={(date) => props.handleConfirm(date, "HoraManana")}
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="city-morning"
                  name="city-morning"
                  disabled
                  label="Seleccionaste (Mañana):"
                  fullWidth
                  value={props.values.fechaMostrar}
                />
              </FormControl>
            </Grid>
            {/* Campos para la tarde */}
            <Grid item xs={12} container justify="space-around">
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ca}>
                <KeyboardDatePicker
                  disabled
                  fullWidth
                  margin="normal"
                  id="date-picker-dialog-afternoon"
                  label="Selecciona una fecha (Tarde)"
                  format="dd/MM/yyyy"
                  value={props.values.fecha}
                  onChange={(date) =>
                    props.handleConfirmTarde(date, "FechaTarde")
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  fullWidth
                  margin="normal"
                  id="time-picker-afternoon"
                  label="Selecciona una hora (Tarde)"
                  ampm={false}
                  value={props.values.horaTarde}
                  onChange={(date) =>
                    props.handleConfirmTarde(date, "HoraTarde")
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="city-afternoon"
                  name="city-afternoon"
                  disabled
                  label="Seleccionaste (Tarde):"
                  fullWidth
                  value={props.values.fechaMostrarTarde}
                />
              </FormControl>
            </Grid>
          </>
        ) : (
          //Cuando es solo mañana
          <>
            <Grid item xs={12} container justify="space-around">
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ca}>
                <KeyboardDatePicker
                  fullWidth
                  margin="normal"
                  id="date-picker-dialog"
                  label="Selecciona una fecha"
                  format="dd/MM/yyyy"
                  value={props.values.fecha}
                  onChange={(date) => props.handleConfirm(date, "Fecha")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
                <KeyboardTimePicker
                  fullWidth
                  margin="normal"
                  id="time-picker"
                  label="Selecciona una hora"
                  ampm={false}
                  value={props.values.hora}
                  onChange={(date) => props.handleConfirm(date, "Hora")}
                  KeyboardButtonProps={{
                    "aria-label": "change time",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="city"
                  name="city"
                  disabled
                  label="Seleccionaste:"
                  fullWidth
                  autoComplete="shipping address-level2"
                  value={props.values.fechaMostrar}
                />
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
      <div className={classes.buttons}>
        {props.activeStep != 0 && (
          <Button onClick={props.prevStep} className={classes.button}>
            Regresar
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={props.nextStep}
          className={classes.button}
        >
          {props.activeStep == 4 && props.activeStep < 5
            ? "Solicitar viaje"
            : "Siguiente"}
        </Button>
      </div>
    </React.Fragment>
  );
}
